import { InjectionToken } from '@angular/core';

import { FirebaseConfig } from './app-config.model';

export const FIREBASE_CONFIG = new InjectionToken<FirebaseConfig>('FIREBASE_CONFIG');
